import request from '@/utils/request'
// 首页界面整体数据查询接口
export function GetIndex(data) {
  return request({
    url: '/html/index',
    method: 'get',
    params: { data }
  })
}



export function GeRmAddress(data) {
  return request({
    url: '/other/address',
    method: 'get',
    params: data
  })
}
// 获取商家list
export function getbusinesslist(data) {
  return request({
    url: '/business/list',
    method: 'post',
    data
  })
}

// 获取商家分类list
export function getbusinesstaglist() {
  return request({
    url: '/business/tag',
    method: 'get'
  })
}
// 获取商家详情
export function getMerchantDetails(params) {
  return request({
    url: `/business/one/${params.id}`,
    method: 'get',
    params
  })
}
// 获取商家详情
export function getmerchantPromotion(params) {
  return request({
    url: `/business/list/recommendation`,
    method: 'get',
    params
  })
}
// 获取生活区轮播图
export function getLifeRotationChart(params) {
  return request({
    url: '/files/list',
    method: 'get',
    params
  })
}

// 获取生活区轮播图
export function getmeunclasslist() {
  return request({
    url: '/class/class/select',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js